import { css } from '@emotion/react';
import { onMobile } from '@/styles/responsive';

const FailedIcon = () => (
  <div css={FailedIconContainer}>
    <img 
      src="/assets/icons/warning.svg" 
      alt="warning icon"
      css={FailedIconSvg}
    />
  </div>
);

function AIFailedTumbnail() {
  return (
    <div css={ThumbnailContainer}>
      <div css={AnimatedBackground} />
      <div css={CenterContent}>
        <FailedIcon />
      </div>
    </div>
  );
}

export default AIFailedTumbnail;

const ThumbnailContainer = css`
  position: relative;
  width: 100%;
  height: 100%;
  aspect-ratio: 310 / 249; /* MediaCard 썸네일 비율 + 1px 세로 */
  background: var(--surface-Critical-Default, #f7cece);
  border-radius: 12px 12px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  ${onMobile} {
    border-radius: 8px;
  }
`;

const AnimatedBackground = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  border-radius: 12px 12px 0 0;

  ${onMobile} {
    border-radius: 8px;
  }
`;

const CenterContent = css`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  ${onMobile} {
    gap: 4px;
  }
`;

const FailedIconContainer = css`
  width: 40px;
  height: 40px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  ${onMobile} {
    width: 32px;
    height: 32px;
  }
`;

const FailedIconSvg = css`
  width: 100%;
  height: 100%;
`;
